import React from "react";
import { Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { isMobile } from "react-device-detect";

function SkeletonAmusementGroupTitle() {
  return isMobile ? (
    <Col xs="12" className="mb-3">
      <Skeleton height={20} width="100%"></Skeleton>
    </Col>
  ) : (
    <Col xs="12" className="mb-3">
      <Skeleton height={20} width="20%"></Skeleton>
    </Col>
  );
}
export default SkeletonAmusementGroupTitle;
